import { Box, Tooltip, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import CarrierHeader from './CarrierHeader';
import CustomCarrier from './CustomCarrier';

import { sxStyled } from '../styles';

const CarrierInfo = ({
  isCustomSearch,
  carrier,
  common_title,
  activeRadio,
  fare_supplier,
  source,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const { user } = useSelector(state => state.userInfo);
  const isAdmin = user?.role?.name === 'admin';

  const content = isCustomSearch ? (
    <CustomCarrier
      carrier={carrier}
      common_title={common_title}
      activeRadio={activeRadio}
    />
  ) : (
    <CarrierHeader carrier={carrier} />
  );

  if (!isAdmin) {
    return <Box sx={sxStyle.titlePay}>{content}</Box>;
  }

  return (
    <Tooltip
      title={`Fare supplier: ${fare_supplier} · Source: ${source}`}
      arrow
      placement="bottom"
      PopperProps={{
        disablePortal: true,
      }}
    >
      <Box sx={sxStyle.titlePay}>{content}</Box>
    </Tooltip>
  );
};

export default CarrierInfo;
